import React from 'react';
import MeteorologyWrapper from 'components/RouteWrappers/Meteorology';
import Meteorology from 'views/Meteorology';
import fieldsRouter from './FieldsRouter';
import weatherRouter from './WeatherRouter';

const meteorologyRouter = {
  path: 'meteorology',
  element: <MeteorologyWrapper />,
  children: [
    { path: '', element: <Meteorology /> },
    fieldsRouter,
    weatherRouter,
  ],
};

export default meteorologyRouter;
